import * as Cookies from 'js-cookie';
import { getDomain } from './api';
export var getAuthToken = function getAuthToken() {
  return Cookies.get('token');
};
export var getCurrentOrganisationId = function getCurrentOrganisationId() {
  return document.cookie.replace( // eslint-disable-next-line no-useless-escape
  /(?:(?:^|.*;\s*)currentOrganisationId\s*\=\s*([^;]*).*$)|^.*$/, '$1');
};
export var getCurrentTeamId = function getCurrentTeamId() {
  return document.cookie.replace( // eslint-disable-next-line no-useless-escape
  /(?:(?:^|.*;\s*)currentTeamId\s*\=\s*([^;]*).*$)|^.*$/, '$1');
};
export var saveOrganisationToCookie = function saveOrganisationToCookie(currentOrganisationId) {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'currentOrganisationId=' + currentOrganisationId + ';domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'currentOrganisationId=' + currentOrganisationId + ';domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'currentOrganisationId=' + currentOrganisationId + ';domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'currentOrganisationId=' + currentOrganisationId + ';path=/';
      break;
  }
};
export var saveTeamToCookie = function saveTeamToCookie(currentTeamId) {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'currentTeamId=' + currentTeamId + ';domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'currentTeamId=' + currentTeamId + ';domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'currentTeamId=' + currentTeamId + ';domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'currentTeamId=' + currentTeamId + ';path=/';
      break;
  }
};
export var saveSwitchToCookie = function saveSwitchToCookie(token, email) {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'switchFromToken=' + token + ';domain=.roymorgandev.com;path=/';
      document.cookie = 'switchFromEmail=' + email + ';domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'switchFromToken=' + token + ';domain=.roymorganuat.com;path=/';
      document.cookie = 'switchFromEmail=' + email + ';domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'switchFromToken=' + token + ';domain=.roymorgan.com;path=/';
      document.cookie = 'switchFromEmail=' + email + ';domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'switchFromToken=' + token + ';path=/';
      document.cookie = 'switchFromEmail=' + email + ';path=/';
      break;
  }
};
/**
 * Calculate domain value for cookie.
 * @param {string} env - Environment.
 */

function cookieDomainForEnv(env) {
  switch (env) {
    case 'dev':
    case 'uat':
    case 'production':
    case 'prod':
      return '.' + getDomain(env) + '.com';

    case 'local':
    default:
      return undefined;
  }
}
/**
 * Calculate the expiration time for the token in milliseconds.
 * @param {string} expiry - Expiration (UTC epoch time).
 */


function cookieExpirationTime(expiry) {
  if (typeof expiry !== 'undefined') {
    // can directly set date using an epoch string
    // (will localise to timezone too!)
    return new Date(expiry);
  } else {
    // If we don't have an expiration time
    // set a default expiration of 8 hours
    var currentTime = new Date().getTime();
    var eightHours = 8 * 60 * 60 * 1000;
    return new Date(currentTime + eightHours);
  }
}

export var saveTokenToCookie = function saveTokenToCookie(token, expiry) {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;
  var domain = cookieDomainForEnv(env);
  var tokenExpiration = cookieExpirationTime(expiry);

  if (domain) {
    Cookies.set('token', token, {
      domain: domain,
      expires: tokenExpiration
    });
  } else {
    Cookies.set('token', token, {
      expires: tokenExpiration
    });
  }
};
/**
 * @deprecated Since version 4.x.
 *             Will be deleted in a future version.
 *             Use saveTokenToCookie instead.
 */

export var saveToCookie = saveTokenToCookie;
export var removeOrganisationAndTeamToCookie = function removeOrganisationAndTeamToCookie() {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'currentOrganisationId=0;expires=0;domain=.roymorgandev.com;path=/';
      document.cookie = 'currentTeamId=0;expires=0;domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'currentOrganisationId=0;expires=0;domain=.roymorganuat.com;path=/';
      document.cookie = 'currentTeamId=0;expires=0;domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'currentOrganisationId=0;expires=0;domain=.roymorgan.com;path=/';
      document.cookie = 'currentTeamId=0;expires=0;domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'currentOrganisationId=0;expires=0;path=/';
      document.cookie = 'currentTeamId=0;expires=0;path=/';
      break;
  }
};
export var removeCookie = function removeCookie() {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'token=0;expires=0;domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'token=0;expires=0;domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'token=0;expires=0;domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'token=0;expires=0;path=/';
      break;
  }
};
export var removeSwitchToCookies = function removeSwitchToCookies() {
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;

  switch (env) {
    case 'dev':
      document.cookie = 'switchFromToken=0;expires=0;domain=.roymorgandev.com;path=/';
      document.cookie = 'switchFromEmail=0;expires=0;domain=.roymorgandev.com;path=/';
      break;

    case 'uat':
      document.cookie = 'switchFromToken=0;expires=0;domain=.roymorganuat.com;path=/';
      document.cookie = 'switchFromEmail=0;expires=0;domain=.roymorganuat.com;path=/';
      break;

    case 'production':
    case 'prod':
      document.cookie = 'switchFromToken=0;expires=0;domain=.roymorgan.com;path=/';
      document.cookie = 'switchFromEmail=0;expires=0;domain=.roymorgan.com;path=/';
      break;

    case 'local':
    default:
      document.cookie = 'switchFromToken=0;expires=0;path=/';
      document.cookie = 'switchFromEmail=0;expires=0;path=/';
      break;
  }
};